/* istanbul ignore file */
import { FormRow, BigFormRow } from 'framework/ui/layout';
import { DateInput, TextInput, ClearAfterUnmountWrapper } from 'framework/form';
import CalendarRightDateInput from 'domain/people/employee/Timeline/feedback/shared/input/CalendarRightDateInput';
import OnBehalfOfInput from 'domain/people/employee/Timeline/feedback/shared/input/OnBehalfOfInput';
import { FeedbackAttachmentUploaderInput, TimelineFeedbackWysiwygInput } from 'domain/shared/employee';
import FeedbackRelationshipDropdown, {
  FEEDBACK_RELATIONSHIP_ALIAS,
} from 'domain/people/employee/Timeline/feedback/form/FeedbackRelationshipDropdown';

const FeedbackForm = () => {
  return (
    <>
      <FormRow colMd={12} colXl={6}>
        <TimelineFeedbackWysiwygInput artifactsSource="attachmentsIds" source="feedbackText" label="Feedback text" />
        <BigFormRow sx={{ pt: { xs: 0, xl: 3 } }}>
          <FormRow colMd={6} colXl={6}>
            <DateInput source="relatedPeriodStart" label="Related period from" />
            <CalendarRightDateInput source="relatedPeriodEnd" label="Related period to" />
          </FormRow>
          <OnBehalfOfInput
            onBehalfOfSource="onBehalfOf"
            onBehalfOfEmployeeSource="onBehalfOfEmployee"
            onBehalfOfEmployeeNameSource="onBehalfOfEmployeeName"
            label="On behalf of"
          />
          <FeedbackRelationshipDropdown source="relationship" />
          <ClearAfterUnmountWrapper isVisible={data => data.relationship !== FEEDBACK_RELATIONSHIP_ALIAS.NO_RELATION}>
            <TextInput source="relatedClient" label="Related Client" />
          </ClearAfterUnmountWrapper>
          <ClearAfterUnmountWrapper isVisible={data => data.relationship !== FEEDBACK_RELATIONSHIP_ALIAS.NO_RELATION}>
            <TextInput source="relatedProject" label="Related Project" />
          </ClearAfterUnmountWrapper>
        </BigFormRow>
      </FormRow>
      <BigFormRow>
        <FeedbackAttachmentUploaderInput label="Feedback files" source="attachmentsIds" />
      </BigFormRow>
    </>
  );
};

export default FeedbackForm;
